import { render } from "./ErrorHandler.vue?vue&type=template&id=1d30dff0&ts=true"
import script from "./ErrorHandler.vue?vue&type=script&lang=ts"
export * from "./ErrorHandler.vue?vue&type=script&lang=ts"

import "./ErrorHandler.vue?vue&type=style&index=0&id=1d30dff0&lang=scss"

import exportComponent from "/home/runner/work/on-the-edge-client/on-the-edge-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__